<template>
  <div>
    系统配置
    <div class="menu-config">
        <div class="page-card">
          <label>配置项相关操作：</label>
          <el-button class="mb10" type="primary" size="small" @click="cacheRefresh(1)">公共类缓存</el-button>
          <el-button class="mb10" type="primary" size="small" @click="cacheRefresh(2)">接口权限缓存</el-button>
          <el-button class="mb10" type="primary" size="small" @click="cacheRefresh(3)">租户个性化缓存</el-button>
          <el-button class="mb10" type="primary" size="small" @click="cacheRefresh(4)">公告缓存</el-button>
          <!-- <el-button class="mb10" type="primary" size="small" @click="exportColumn()">导入表头</el-button> -->
        </div>
        <!-- <div class="page-card">
          <label>配置复制：</label>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="copy_data.ids" class="search-input" placeholder="流程配置id或字典类型,多个用 | 分割，全部填“all”"></el-input>
          <el-input v-model="copy_data.from" class="search-input" placeholder="源center_id"></el-input>
          <el-input v-model="copy_data.to" class="search-input" placeholder="目标center_id"></el-input>
          <el-select class="input150 ml10 mr10" filterable v-model="copy_data.copy_type" placeholder="请选择配置类型">
            <el-option
              v-for="item in copy_type"
              :key="item.id"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button class="mb10" type="primary" size="small" @click="coypConfigData()">复制</el-button>
        </div> -->
        <!-- <div class="page-card">
          <label>菜单相关操作：</label>
          <el-button class="mb10" type="primary" size="small" @click="expmenuSave()">导入菜单</el-button>
        </div> -->
        <!-- <div class="page-card">
          <label>批量添加人员菜单：</label>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="user_menu.menu_ids" class="search-input" placeholder="菜单id，多个用 | 分割，必填"></el-input>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="user_menu.uids" class="search-input" placeholder="人员id，多个用 | 分割，全部填all,"></el-input>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="user_menu.role_ids" class="search-input" placeholder="角色id，多个用 | 分割"></el-input>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="user_menu.user_types" class="search-input" placeholder="人员类型值，多个用 | 分割"></el-input>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="user_menu.department_ids" class="search-input" placeholder="科室id，多个用 | 分割"></el-input>
          <el-button class="mb10" type="primary" size="small" @click="saveUserMenu(1)">添加菜单权限</el-button>
          <el-button class="mb10" type="primary" size="small" @click="saveUserMenu(2)">删除菜单权限</el-button>
        </div> -->
        <!-- <div class="page-card">
          <label>刻码包REDIS清理：</label>
          <el-input v-model="inner_code.code" class="search-input" placeholder="包刻码，不支持多个同时处理"></el-input>
          <el-button class="mb10" type="primary" size="small" @click="cleanInnerCodeCache()">清除</el-button>
        </div> -->
        
        <!-- <div class="page-card">
          <label>导出日志：</label>
           <el-date-picker
            v-model="log.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日志的日期">
          </el-date-picker>
          <el-button class="mb10" type="primary" size="small" @click="downloadLog()">导出日志</el-button>
        </div> -->
       
        <!-- <div class="page-card">
            <label> 设备登记导入导出：</label>
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="register_info.equipment_ids" class="search-input" placeholder="设备id，多个用 | 分割，必填"></el-input>
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 20 }" v-model="register_info.register_json" class="search-input" placeholder="登记的json格式"></el-input>

            <el-button class="mb10" type="primary" size="small" @click="sysRegisterOptionSave()">提交</el-button>
            <el-button class="mb10" type="primary" size="small" @click="sysRegisterOptionExport()">导出</el-button>

            <el-button class="mb10" type="primary" size="small" @click="sysRegisterOptionExportTemplate()">导出新版本登记模板(导出内容复制到json.cn查看)</el-button>
        </div> -->
<!-- 
        <div class="page-card">
          <label>日志查询：</label>
          日志日期：
          <el-date-picker
            v-model="log.search.date"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="默认当天">
          </el-date-picker>
          日志名称：
          <el-input v-model="log.search.log_name" class="search-input" placeholder="不需要加.log"></el-input>
          显示行数：
          <el-input v-model="log.search.line" class="search-input" placeholder="显示行数"></el-input>行
          <el-button class="mb10" type="primary" size="small" @click="readLog()">查询</el-button>
          <div>
            <pre v-for="(item, index) in log.list" :key="index" class="log">{{item}}</pre>
          </div>
        </div> -->
      </div>
       <el-backtop></el-backtop>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { 
  sysCacheRefresh, 
  sysTypeSave, 
  sysOptionSave,
  sysColumnSave,
  sysMenuSave,
  sysUserMenuBatch,
  sysInnerCodeStuckDelete,
  readLog,
  sysTypeCopy,
  sysOptionCopy,
  registerSave,
  registerExport,
  registerExportTemplate
} from '@/api.js'
export default {
  name: 'SysConfig',
  data() {
    return {
      domain: 'http://' + document.domain,
      user_menu:{
        menu_ids:'',
        uids:'',
        role_ids:'',
        user_types:'',
        department_ids:'',
      },
      inner_code:{
        code:''
      },
      log:{
        search:{
          date:'',
          log_name:'',
          line:30
        },
        list:[]
      },
      copy_type:[
        {
          'id':1,
          'name':'流程配置',
          'value':1
        },
        {
          'id':2,
          'name':'数据字典',
          'value':2
        }
      ],
      copy_data:{
        ids:'',
        from:'',
        to:'',
        copy_type:''
      },
      register_info:{
          equipment_ids:'',
          register_json:''
      },
      exportedText: null,
    }
  },
      computed: {
        ...mapGetters(['user', 'exec', 'system', 'btnauth', 'pda'])
        
    },
  created() {
    //this.getDomain()
  },
  methods: {
    //获取接口域名和端口
    getDomain(){
      let port = window.location.port
      if(port == '80' || port == '443' || port == '8002'){
        port = '9501'
      }else if (port == '9700'){
        port = '9701'
      }else{
        port = '9601'
      }
      this.domain = this.domain + ':' + port + ''
    },

    //配置项复制
    coypConfigData(){
      if(this.copy_data.copy_type === null || this.copy_data.copy_type === ''){
        this.$message.error('请选择配置类型')
        return 
      }
      let url = this.copy_data.copy_type == 1 ? sysTypeCopy : sysOptionCopy;
      this.$request('post', url, this.copy_data)
      .then((res) => {
        if (res) {
          this.$message.success(res);
          this.copy_data = {
            ids:'',
            from:'',
            to:'',
            copy_type:''
          }
        }
      })
    },

    //导入流程配置
    exportSysType(){
      this.$request('get', sysTypeSave, {})
      .then((res) => {
        if (res) {
          this.$message.success(res)
        }
      })
    },

  //导出登记
  exportRegister(){
      this.$request('get', sysTypeSave, {})
          .then((res) => {
              if (res) {
                  this.$message.success(res)
              }
          })
  },

    //导入数据字典
    exportSysOption(){
      this.$request('get', sysOptionSave, {})
      .then((res) => {
        if (res) {
          this.$message.success(res)
        }
      })
    },
    sysRegisterOptionSave(){
        this.$request('post', registerSave , this.register_info)
            .then((res) => {
                if (res) {
                    this.$message.success(res)
                    this.register_info = {
                        equipment_ids:'',
                        register_json:'',
                    }
                }
            })
    },
  sysRegisterOptionExport(){
      if(this.register_info.equipment_ids==''){
          this.$message.error('请按规定输入设备id')
          return;
      }

      this.$utils.exportFile(registerExport, this.register_info)
  },
  sysRegisterOptionExportTemplate(){
      this.$utils.exportFile(registerExportTemplate, this.register_info)
  },

    //导入表头
    exportColumn(){
      this.$request('get', sysColumnSave, {})
      .then((res) => {
        if (res) {
          this.$message.success(res)
        }
      })
    },

    //导入菜单
    expmenuSave(){
      this.$request('get', sysMenuSave, {})
      .then((res) => {
        if (res) {
          this.$message.success(res)
        }
      })
    },

    //保存人员权限
    saveUserMenu(type){
      this.$request('post', sysUserMenuBatch + type, this.user_menu)
      .then((res) => {
        if (res) {
          this.$message.success(res)
          this.user_menu = {
            menu_ids:'',
            uids:'',
            role_ids:'',
            user_types:'',
            department_ids:'',
          }
        }
      })
    },

    //刷新缓存
    cacheRefresh(num){
      this.$request('get', sysCacheRefresh, {
        type:num
      })
      .then((res) => {
        if (res) {
          this.$message.success("刷新成功")
        }
      })
    },

    //刻码包缓存处理
    cleanInnerCodeCache(){
      this.$request('post', sysInnerCodeStuckDelete + this.inner_code.code, {})
      .then((res) => {
        if (res) {
          this.$message.success(res)
          this.inner_code.code = ''
        }
      })
    },

    //读取日志
    readLog(){
      if(this.log.search.log_name === null || this.log.search.log_name === ''){
        this.$message.error('文件名不能为空')
        return 
      }
      if(this.log.search.date === null || this.log.search.date === ''){
        this.$moment(this.system.time).format('yyyy/MM/DD')
      }
      this.$request('post', readLog, this.log.search)
      .then((res) => {
        if (res) {
          console.log(res)
          this.log.list = res
        }
      })
    },

    //导出日志
    downloadLog(){
      let url = this.domain + '/sys/download/create/log';
      this.$request('get', url, {
        date:this.log.date
      })
      .then((res) => {
        if (res) {
          this.checkDownloadLog(res);
          //this.$message.success(res)
          //this.inner_code.code = ''
        }
      })
    },

    checkDownloadLog(download_url){
      let timer = null;
      let url = this.domain + '/sys/download/get/log';
      this.$request('get', url, {
        path:download_url
      }).then((res) => {
        if(res === true){
          console.log(download_url)
          clearTimeout(timer)
        }else{
          timer = setTimeout(()=>{
            this.checkDownloadLog(download_url);
          },2000)
        }
      })
    },
  }
}
</script>

<style scoped>
  .log {
    margin: 10px;
    padding: 10px;
    border-bottom: 1px solid lightgray;
    word-break: break-all;
    white-space: unset;
  }
</style>